/**
 * useAtualizacaoAoVivo — o cache de TARPs e planos acompanha o que os outros fazem (C-24).
 *
 * Antes só a tela de TARP (`useOpenTarps`) assinava o `tarp:critical`: em qualquer outra
 * tela, a TARP baixada por outro RT continuava no sino até o próximo polling, e plano não
 * tinha evento nenhum. Montado pelo sino, que existe em toda tela com usuário logado.
 *
 * As ações do PRÓPRIO cliente não chegam por aqui (`broadcast.self: false`): elas já
 * invalidam o cache nas mutations. O polling continua como rede de segurança — escrita fora
 * do app e leitura de instrumento (cron) não têm evento.
 */
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { subscribeTarpCritical } from '@/services/datasources/tarp-realtime';
import { subscribePlanos } from '@/services/datasources/planos-realtime';

export function useAtualizacaoAoVivo(): void {
  const qc = useQueryClient();

  useEffect(() => {
    const pararTarp = subscribeTarpCritical((p) => {
      void qc.invalidateQueries({ queryKey: ['tarps'] });
      // A baixa cria o plano ANTES de encerrar a TARP (GUPM-213): o `close` é o sinal de
      // que pode haver plano novo — o `create` do plano já foi, mas chega por outro tópico
      // e pode se perder; o custo de invalidar de novo é uma consulta.
      if (p.event === 'close') void qc.invalidateQueries({ queryKey: ['planos'] });
    });
    const pararPlanos = subscribePlanos(() => {
      void qc.invalidateQueries({ queryKey: ['planos'] });
    });
    return () => {
      pararTarp();
      pararPlanos();
    };
  }, [qc]);
}
